// Expose jQuery to the worl.. *ahem*, to the external dependencies that
// assume jQuery is in the global scope. See:  https://www.youtube.com/watch?v=F-mjl63e0ms
import $ from 'jquery'

window.$ = $
window.jQuery = $

// Set webpack publicPath from config
__webpack_public_path__ = window.InterNations.publicPath // eslint-disable-line no-undef,camelcase
